<template>
  <div class="ma-2 pa-2">
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          :color="getStatusColor(pipelineEvent.status)"
          hide-details="auto"
          filled
          dense
          label="status"
          :value="pipelineEvent.status"
          readonly
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          hide-details="auto"
          filled
          dense
          label="Platform"
          :value="pipelineEvent.platform"
          readonly
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          hide-details="auto"
          filled
          dense
          label="Platform Order ID"
          :value="pipelineEvent.platform_order_uuid"
          readonly
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field
          hide-details="auto"
          filled
          dense
          label="Restaurant platform ID"
          :value="pipelineEvent.restaurant_platform_id"
          readonly
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { pipeline } from ".";
export default {
  props: {
    pipelineEvent: { type: Object },
  },
  methods: {
    getStatusColor: (status) => pipeline.getStatusColor(status),
  },
};
</script>
